export const ADMIN_FAQS = [
  // ==================== OTP & VERIFICATION ====================
  {
    id: 'otp-not-received',
    category: 'OTP & Verification',
    question: 'I did not receive OTP on my phone',
    keywords: ['otp', 'not received', 'sms', 'phone', 'verification'],
    answer:
      'Use number in +91 format (example: +919876543210), then retry OTP. If still not delivered, check Twilio delivery reason in the message and contact support.',
    contactHint: 'Support: +91-9876543210 | support@assetflow.in'
  },
  {
    id: 'otp-expired',
    category: 'OTP & Verification',
    question: 'My OTP expired before I entered it',
    keywords: ['otp', 'expired', 'timeout', 'invalid otp', 'new otp'],
    answer:
      'OTP has limited validity. Generate a fresh OTP and verify immediately. Always use the latest OTP received.',
    contactHint: 'If expiry is too frequent, check server time and retry.'
  },
  {
    id: 'otp-wrong',
    category: 'OTP & Verification',
    question: 'OTP verification says invalid OTP',
    keywords: ['invalid otp', 'wrong otp', 'verification failed', 'otp mismatch'],
    answer:
      'Make sure you entered the latest 6-digit OTP. If multiple OTPs were generated, older ones become invalid.',
    contactHint: 'Retry once with a newly generated OTP.'
  },
  {
    id: 'resend-otp',
    category: 'OTP & Verification',
    question: 'How can I resend OTP?',
    keywords: ['resend', 'otp', 'send again', 'generate otp again'],
    answer:
      'Click Generate OTP again with the same mobile number in E.164 format. The latest OTP will replace previous ones.',
    contactHint: 'Use +91XXXXXXXXXX format for Indian numbers.'
  },
  {
    id: 'invalid-phone',
    category: 'OTP & Verification',
    question: 'Phone number is invalid while generating OTP',
    keywords: ['invalid', 'phone', 'number', 'format', 'twilio'],
    answer:
      'Please enter your mobile in international format with country code. For India, use +91 followed by 10 digits.',
    contactHint: 'If issue continues, contact backend support.'
  },
  {
    id: 'twilio-trial-restriction',
    category: 'OTP & Verification',
    question: 'OTP is generated but SMS still not delivered',
    keywords: ['twilio', 'trial', 'sms not delivered', 'provider reason', 'delivery failed'],
    answer:
      'Check the SMS delivery reason shown in UI. Twilio trial accounts can only send to verified numbers and require valid international format.',
    contactHint: 'Verify recipient number in Twilio console if using trial mode.'
  },
  {
    id: 'plan-limit-reached',
    category: 'Plans & Subscription',
    question: 'User or asset limit reached for current plan',
    keywords: ['limit', 'reached', 'plan', 'users', 'assets', 'upgrade', 'renew'],
    answer:
      'Your current subscription limit is reached. Open View Plans and upgrade or renew your plan to continue adding users/assets.',
    contactHint: 'Need help choosing plan? Contact billing team.'
  },
  {
    id: 'which-plan-to-choose',
    category: 'Plans & Subscription',
    question: 'Which plan should I choose?',
    keywords: ['which plan', 'recommend plan', 'starter', 'professional', 'enterprise', 'best plan'],
    answer:
      'Choose based on user and asset limits. If you are near limits, upgrade now to avoid operational blocking.',
    contactHint: 'Share team size and asset count with billing for plan recommendation.'
  },
  {
    id: 'upgrade-vs-renew',
    category: 'Plans & Subscription',
    question: 'What is the difference between upgrade and renewal?',
    keywords: ['upgrade', 'renewal', 'difference', 'plan change'],
    answer:
      'Upgrade changes your plan capacity/features. Renewal extends validity for your current plan cycle.',
    contactHint: 'Use View Plans to upgrade and Invoices/Subscriptions to track renewals.'
  },
  {
    id: 'downgrade-plan',
    category: 'Plans & Subscription',
    question: 'Can I downgrade my plan?',
    keywords: ['downgrade', 'lower plan', 'reduce plan'],
    answer:
      'Downgrade is usually processed at cycle boundary to avoid active usage conflicts with lower limits.',
    contactHint: 'Contact billing to schedule downgrade safely.'
  },
  {
    id: 'plan-expired-what-next',
    category: 'Plans & Subscription',
    question: 'My plan expired, what should I do?',
    keywords: ['plan expired', 'subscription expired', 'renew now', 'expired plan'],
    answer:
      'Renew your plan from View Plans to restore full access and continue operations without interruption.',
    contactHint: 'If renewal fails, contact billing support immediately.'
  },
  {
    id: 'when-to-renew',
    category: 'Plans & Subscription',
    question: 'When should I renew my plan?',
    keywords: ['when renew', 'renewal time', 'before expiry', 'renew subscription'],
    answer:
      'Renew before expiry, ideally a few days early, to avoid service interruption and pending operations.',
    contactHint: 'Track remaining days from View Plans or subscription section.'
  },
  {
    id: 'add-new-user',
    category: 'Users & Team',
    question: 'How do I add a new user?',
    keywords: ['add user', 'create user', 'manage users', 'new account'],
    answer:
      'Go to Manage Users, choose Add User, select role, fill details, and submit.',
    contactHint: 'Ensure your plan user limit is not reached.'
  },
  {
    id: 'add-asset-technician',
    category: 'Users & Team',
    question: 'How to add Asset Technician?',
    keywords: ['add technician', 'asset technician', 'technician user'],
    answer:
      'Open Manage Users, choose Add Asset Technician, enter required details, then save.',
    contactHint: 'Assign proper department/role while creating technician.'
  },
  {
    id: 'add-asset-incharge',
    category: 'Users & Team',
    question: 'How to add Asset Incharge?',
    keywords: ['add incharge', 'asset incharge', 'create incharge'],
    answer:
      'Go to Manage Users, select Add Asset Incharge, fill details, and submit.',
    contactHint: 'Use valid contact details and department mapping.'
  },
  {
    id: 'pending-approvals-location',
    category: 'Users & Team',
    question: 'Where can I see pending approvals?',
    keywords: ['pending approvals', 'approval queue', 'review requests'],
    answer:
      'Open Pending Approvals section to review all awaiting user or request approvals.',
    contactHint: 'Process pending requests regularly to avoid delays.'
  },
  {
    id: 'approve-user-request',
    category: 'Users & Team',
    question: 'How to approve user requests?',
    keywords: ['approve user', 'reject request', 'user approval'],
    answer:
      'Go to Pending Approvals, open the request, review details, then click Approve or Reject.',
    contactHint: 'Rejected requests should include clear reason when possible.'
  },
  {
    id: 'add-department',
    category: 'Departments',
    question: 'How do I add a department?',
    keywords: ['add department', 'create department', 'manage departments'],
    answer:
      'Go to Manage Departments, click Add Department, enter the department name, and save.',
    contactHint: 'Keep department names unique and standardized.'
  },
  {
    id: 'view-departments',
    category: 'Departments',
    question: 'How to view departments?',
    keywords: ['view departments', 'department list', 'all departments'],
    answer:
      'Open Manage Departments to see all active departments and their details.',
    contactHint: 'Update obsolete departments to keep mapping clean.'
  },
  {
    id: 'view-assets-inventory',
    category: 'Assets',
    question: 'How do I view all assets?',
    keywords: ['view assets', 'inventory', 'all assets', 'asset list'],
    answer:
      'Go to View Assets Inventory to see complete asset records and statuses.',
    contactHint: 'Use filters for status, category, and department.'
  },
  {
    id: 'add-asset-workflow',
    category: 'Assets',
    question: 'How do I add an asset?',
    keywords: ['add asset', 'create asset', 'new asset entry'],
    answer:
      'Use Add Asset in asset management, fill required fields, and save the record.',
    contactHint: 'Include serial number and category for better tracking.'
  },
  {
    id: 'check-unused-assets',
    category: 'Assets',
    question: 'How to check unused assets?',
    keywords: ['unused assets', 'available assets', 'not assigned', 'free assets'],
    answer:
      'In View Assets Inventory, filter by Available or Not Assigned status to find unused assets.',
    contactHint: 'Review these assets for reallocation opportunities.'
  },
  {
    id: 'asset-user-requests-location',
    category: 'Assets',
    question: 'Where are asset user requests?',
    keywords: ['asset user requests', 'pending asset requests', 'request queue'],
    answer:
      'Open Pending Asset User Requests to view all new or pending asset allocation requests.',
    contactHint: 'Approve valid requests to reduce wait time.'
  },
  {
    id: 'approve-asset-request',
    category: 'Assets',
    question: 'How to approve asset request?',
    keywords: ['approve asset request', 'reject asset request', 'asset request approval'],
    answer:
      'Open the request in Pending Asset User Requests and click Approve or Reject after review.',
    contactHint: 'Confirm availability before approving.'
  },
  {
    id: 'check-issues',
    category: 'Issues',
    question: 'How do I check issues?',
    keywords: ['check issues', 'equipment issues', 'complaints', 'issue list'],
    answer:
      'Go to Equipment Issues to view all reported issues and their current status.',
    contactHint: 'Use filters to prioritize by severity and status.'
  },
  {
    id: 'pending-issues',
    category: 'Issues',
    question: 'What are pending issues?',
    keywords: ['pending issues', 'in progress issues', 'open issues'],
    answer:
      'Pending issues are tickets currently marked Pending or In Progress and not yet resolved.',
    contactHint: 'Assign owners and update status regularly.'
  },
  {
    id: 'resolve-issue',
    category: 'Issues',
    question: 'How to resolve an issue?',
    keywords: ['resolve issue', 'close issue', 'mark resolved'],
    answer:
      'After fixing the problem, update issue status to Resolved with relevant notes.',
    contactHint: 'Include resolution details for future reference.'
  },
  {
    id: 'invoice-download',
    category: 'Invoices & Billing',
    question: 'Unable to view or download invoice',
    keywords: ['invoice', 'download', 'view', 'billing', 'pdf'],
    answer:
      'Go to Manage Invoices section and click View or Download. If invoice is missing, refresh once and check again.',
    contactHint: 'For missing invoices, contact billing@assetflow.in'
  },
  {
    id: 'invoice-missing-after-payment',
    category: 'Invoices & Billing',
    question: 'Payment done but invoice is missing',
    keywords: ['payment done', 'invoice missing', 'invoice not generated', 'billing record'],
    answer:
      'Wait briefly and refresh invoices list. If still missing, share company name, plan, and payment timestamp with billing support.',
    contactHint: 'billing@assetflow.in'
  },
  {
    id: 'invoice-company-name-change',
    category: 'Invoices & Billing',
    question: 'Company name is wrong in invoice',
    keywords: ['invoice name wrong', 'company name invoice', 'invoice correction'],
    answer:
      'Invoice details come from saved company profile at purchase time. Update company profile before next billing cycle.',
    contactHint: 'Contact billing for correction workflow if already issued.'
  },
  {
    id: 'gst-tax-question',
    category: 'Invoices & Billing',
    question: 'How are taxes calculated in invoice?',
    keywords: ['gst', 'tax', 'invoice tax', 'tax rate'],
    answer:
      'Invoice total includes base amount plus configured tax rate. Check line items in invoice preview/download for exact values.',
    contactHint: 'For taxation questions, contact billing with invoice number.'
  },
  {
    id: 'data-export',
    category: 'Data Export',
    question: 'How to download company data export',
    keywords: ['download', 'data', 'export', 'zip', 'company_data'],
    answer:
      'Open Download your data section from admin sidebar and click Download company_data.zip. Only your company data is included.',
    contactHint: 'If ZIP fails, try again after refreshing your session.'
  },
  {
    id: 'data-export-files',
    category: 'Data Export',
    question: 'What files are included in company_data.zip?',
    keywords: ['zip files', 'what included', 'company_data zip content', 'export files'],
    answer:
      'Export includes core datasets like company, users, assets, assignments, issues, maintenance, notifications, and related documents when available.',
    contactHint: 'If documents are not present, ZIP may include a placeholder note.'
  },
  {
    id: 'data-export-scope',
    category: 'Data Export',
    question: 'Can I download data of another company?',
    keywords: ['another company', 'other company data', 'scope', 'permissions'],
    answer:
      'No. Admin export is strictly restricted to your own company data only.',
    contactHint: 'This is enforced by backend authorization.'
  },
  {
    id: 'data-export-failed',
    category: 'Data Export',
    question: 'Data export download failed',
    keywords: ['export failed', 'zip failed', 'download failed', 'network error'],
    answer:
      'Retry download from the data export section. If it fails repeatedly, re-login and try again with stable internet.',
    contactHint: 'Share error screenshot with support for faster debugging.'
  },
  {
    id: 'plan-purchase-support',
    category: 'Payment',
    question: 'Need help while buying plan',
    keywords: ['buy', 'plan', 'payment', 'gateway', 'subscription', 'purchase'],
    answer:
      'You can continue from View Plans to Buy Plan. Complete OTP verification first, then proceed to payment gateway.',
    contactHint: 'Payment support: +91-9876543210 | billing@assetflow.in'
  },
  {
    id: 'payment-failed',
    category: 'Payment',
    question: 'Payment failed after OTP verification',
    keywords: ['payment failed', 'gateway failed', 'transaction failed', 'otp verified payment issue'],
    answer:
      'If OTP is verified but payment fails, retry the payment step. Do not re-purchase multiple times until status is confirmed.',
    contactHint: 'Contact billing with transaction reference if amount was debited.'
  },
  {
    id: 'subscription-status-check',
    category: 'Plans & Subscription',
    question: 'How do I check my subscription status?',
    keywords: ['subscription status', 'active plan', 'days remaining', 'renewal date'],
    answer:
      'Open View Plans or subscription section to check current plan, renewal date, and days remaining.',
    contactHint: 'Near-expiry plans should be renewed early to avoid access interruptions.'
  },
  {
    id: 'support-contacts',
    category: 'Support',
    question: 'How can I contact support?',
    keywords: ['support', 'help desk', 'contact', 'phone', 'email'],
    answer:
      'Support Phone: +91-9876543210\nSupport Email: support@assetflow.in\nBilling Email: billing@assetflow.in',
    contactHint: 'Share company name and screenshot for faster resolution.'
  },
  {
    id: 'general-capabilities',
    category: 'Support',
    question: 'What can you help me with?',
    keywords: ['what can you do', 'help topics', 'capabilities', 'bot help'],
    answer:
      'I can help with OTP issues, subscriptions, users, approvals, departments, assets, issues, invoices, and company data export.',
    contactHint: 'Ask a specific workflow question for step-by-step guidance.'
  }
];

export const CHATBOT_QUICK_QUESTIONS = [
  'I did not receive OTP',
  'My OTP expired, what now?',
  'How do I resend OTP?',
  'How do I add a new user?',
  'Where can I see pending approvals?',
  'How do I add a department?',
  'How do I view all assets?',
  'How to check unused assets?',
  'Where are asset user requests?',
  'How do I check issues?',
  'My phone number shows invalid',
  'SMS generated but not delivered',
  'Plan limit reached, what should I do?',
  'My plan expired, what should I do?',
  'When should I renew my plan?',
  'Upgrade vs renewal difference?',
  'Payment failed after OTP verification',
  'How do I download invoice?',
  'Payment done but invoice missing',
  'How to download company data?',
  'What is included in company_data.zip?',
  'How do I check subscription status?',
  'How to contact support?'
];

// Extract unique categories and sort alphabetically
export const FAQ_CATEGORIES = Array.from(
  new Set(ADMIN_FAQS.map(faq => faq.category))
).sort();

// Get FAQs filtered by category
export const getFaqsByCategory = (category) => {
  return ADMIN_FAQS.filter(faq => faq.category === category);
};
